import { render, staticRenderFns } from "./SumupList.vue?vue&type=template&id=ca48b522&"
import script from "./SumupList.vue?vue&type=script&lang=ts&"
export * from "./SumupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports